import { render, staticRenderFns } from "./addDistrict.vue?vue&type=template&id=7556c9e9&"
import script from "./addDistrict.vue?vue&type=script&lang=js&"
export * from "./addDistrict.vue?vue&type=script&lang=js&"
import style0 from "./addDistrict.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports